import React from 'react';
import injectSheet from 'react-jss';
import PropTypes from 'prop-types';

class AssetOptionsModal extends React.Component {
    render() {
        const {
            classes,
            onEdit,
            onRename,
            onMoveAsset,
            onCopyAsset,
            onDeleteAsset,
            onClose,
            show,
            isAdmin,
            asset,
        } = this.props;

        if (!show) {
            return null;
        }

        return (
            <div className={classes.container}>
                <div className={classes.modal}>
                    <div className={classes.options}>
                        <button onClick={onRename}>
                            <span>Rename</span>
                        </button>

                        <button onClick={onEdit}>
                            <span>Edit</span>
                        </button>

                        {isAdmin && (
                            <button onClick={onMoveAsset}>
                                <span>Move To...</span>
                            </button>
                        )}

                        {asset.visualizationType ? ( // hotfix disable copying mapspice assets due to gb asset copying issue
                            <button onClick={onCopyAsset}>
                                <span>Copy To...</span>
                            </button>
                        ) : null}

                        {isAdmin && onDeleteAsset && (
                            <button
                                className={classes.deleteOption}
                                onClick={onDeleteAsset}
                            >
                                <span>Delete</span>
                            </button>
                        )}
                    </div>
                </div>
                <div className={classes.background} onClick={onClose} />
            </div>
        );
    }
}

AssetOptionsModal.propTypes = {
    asset: PropTypes.object,
    isAdmin: PropTypes.bool,
    onEdit: PropTypes.func,
    onRename: PropTypes.func,
    onMoveAsset: PropTypes.func,
    onCopyAsset: PropTypes.func,
    onDeleteAsset: PropTypes.func,
    onClose: PropTypes.func,
    show: PropTypes.bool,
};

const style = ({ palette, typography }) => ({
    container: {
        width: 0,
        height: 0,
    },
    modal: {
        backgroundColor: 'white',
        width: '140px',
        height: 'auto',
        position: 'relative',
        left: '-140px',
        bottom: '-17px',
        zIndex: '128',
        borderRadius: '4px',
        boxShadow: '0 0 8px 0 rgba(0,0,0,0.12), 0 8px 8px 0 rgba(0,0,0,0.08)',
    },
    options: {
        display: 'flex',
        flexDirection: 'column',
        borderRadius: '4px',
        overflow: 'hidden',
        '& button': {
            outline: 'none',
            border: 'none',
            height: '36px',
            textAlign: 'start',
            backgroundColor: 'white',
            display: 'flex',
            alignItems: 'center',
            font: 'inherit',
            fontSize: typography.caption.fontSize,
            cursor: 'pointer',
            paddingLeft: '15px',
            borderBottom: `1px solid ${palette.background.gray2Color}`,
            '&:hover': {
                backgroundColor: palette.background.gray1Color,
            },
        },
    },
    background: {
        position: 'fixed',
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 100,
    },
    deleteOption: {
        color: palette.secondary.main,
    },
});

export default injectSheet(style)(AssetOptionsModal);



// WEBPACK FOOTER //
// ./src/components/modals/AssetOptionsModal.js